export const C21_COLORS = {
    gold: '#C5A36D',
    darkGold: '#A68B5B',
    lightGold: '#D4C4A8',
    black: '#1A1A1A',
    darkGray: '#333333',
    warmBrown: '#8B7355',
};
